export const environment = {
  appInsights: {  
    instrumentationKey: '81909031-a339-43f4-bf07-078d08cf8ffc'  
}  ,

production: false,
apiUrl: 'https://smb-api-release.fadv.com',
hotjarConfig:{
  id: 3894761,
  version: 6
}
};